module.exports = __WEBPACK_EXTERNAL_MODULE_50__;


//////////////////
// WEBPACK FOOTER
// external "fenix-ui-metadata-editor"
// module id = 50
// module chunks = 0